<p [innerHTML]="'adv-room-search-results works!'">
</p>
